import type { DragEventHandler } from 'react'
import type { ButtonProps, SRT_RowData, SRT_TableInstance } from '../../types'

import { GripVerticalIcon } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

import { cn } from '../../lib/utils'

export type SRT_GrabHandleButtonProps<TData extends SRT_RowData> = {
	location?: 'column' | 'row'
	onDragEnd: DragEventHandler<HTMLButtonElement>
	onDragStart: DragEventHandler<HTMLButtonElement>
	table: SRT_TableInstance<TData>
} & ButtonProps

export const SRT_GrabHandleButton = <TData extends SRT_RowData>({
	className,
	location,
	table,
	title,
	...rest
}: SRT_GrabHandleButtonProps<TData>) => {
	const {
		options: { localization },
	} = table

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					aria-label={title ?? localization.move}
					draggable='true'
					variant='ghost'
					size='icon-sm'
					{...rest}
					onClick={(e) => {
						e.stopPropagation()
						rest?.onClick?.(e)
					}}
					className={cn(
						// Base styles
						'transition-all duration-150',
						// Cursor styles
						'cursor-grab active:cursor-grabbing',
						// Hover styles
						'hover:bg-transparent',
						// Opacity based on location
						location === 'row' ? 'opacity-100' : 'opacity-50 hover:opacity-100',
						className
					)}
				>
					<GripVerticalIcon />
				</Button>
			</TooltipTrigger>
			<TooltipContent>{title ?? localization.move}</TooltipContent>
		</Tooltip>
	)
}
